// extracted by mini-css-extract-plugin
export default {"root":"TrademarkImage_root__MS2VJ","hasError":"TrademarkImage_hasError__oQdIP","image":"TrademarkImage_image__PhfRI","nonInteractive":"TrademarkImage_nonInteractive__qQ74H"};